import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3006/consumer/cart";
};

export const secondURL = () => {
  return APIHost() + ":3016/consumer/checkout";
};

export const thirdURL = () => {
  return APIHost() + ":3006/consumer/order";
};

export const fourthURL = () => {
  return APIHost() + ":3005/consumer";
};

export const restaurantDirectCheckout = (params) => {
  // const url = `${baseURL()}/directCheckout`;
  const url = `${secondURL()}/directCheckout`;
  return axios.post(url, params);
};

export const restaurantDirectCheckoutCOD = (params) => {
  const url = `${secondURL()}/codCheckout`;
  return axios.post(url, params);
};

export const getCODMaxAmount = () => {
  const url = `${thirdURL()}/getCODMaxAmount`;
  return axios.get(url);
};

export const getDeliveryETA = (params) => {
  //   const url = `${baseURL()}/getDeliveryETA`;
  const url = `${fourthURL()}/getDeliveryETA_v2`;
  return axios.post(url, params);
};

export const getSpecialArea = (params) => {
  const url = `${baseURL()}/getDeliveryAreaList`;
  return axios.post(url, params);
};

export const checkRiderAvailability = () => {
  const url = `${baseURL()}/getRiderAvailability`;
  return axios.get(url);
};

export const checkOrderTypeAndTime = (params) => {
  const url = `${baseURL()}/checkOrderTime`;
  return axios.post(url, params);
};

export const availableOrderingTime = (params) => {
  const url = `${baseURL()}/orderDateTime/${params.id}`;
  return axios.post(url, params);
};

export const dineInPayment = (params) => {
  const url = `${baseURL()}/DineInPayment`;
  return axios.post(url, params);
};
